import { lazy } from 'react';

const Edit = lazy(() => import('./form/edit'));
const Create = lazy(() => import('./form/create'));
const List = lazy(() => import('./list'));
export { List, Edit, Create };
